import React from 'react'

interface IcInfoCircleProps extends React.SVGProps<SVGSVGElement> {
  width?: string
  height?: string
  color?: string
  style?: React.CSSProperties
}

const IcInfoCircle: React.FC<IcInfoCircleProps> = ({
  width = '16px',
  height = '16px',
  color = '#111827',
  style,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0, ...style }}
      color={color}
      {...props}
    >
      <path
        d="M8 10.8889V8M8 5.11111H8.00722M14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IcInfoCircle
